import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { ModalTyC } from "../Componentes/ModalTyC";
import { ModalAP } from "../Componentes/ModalAP";

export const Contact = (props) => {
  const navigate = useNavigate();
  const [showTyC, setShowTyC] = useState(false);
  const [showAP, setShowAP] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => {
    navigate("/metrominuto");
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <style>{`
        .footer a:hover {
          color: #ff0 !important;
        }
      `}</style>

      <footer id="footer" className="footer" style={footerStyle}>
        <div className="container" style={containerStyle}>
          <div className="footer-content" style={footerContentStyle}>

            {/* ——— LEFT SECTION: LOGOS ——— */}
            <div className="left-section" style={leftSectionStyle}>
              <img
                src="./img/unam.jpg"
                alt="Logo UNAM"
                style={unamLogoStyle}
              />
              <div style={subLogosContainerStyle}>
                <img
                  src="./img/iimas.png"
                  alt="Logo IIMAS"
                  style={subLogoStyle}
                />
                <img
                  src="./img/faviconC310.png"
                  alt="Logo C3"
                  style={subLogoStyle2}
                />
              </div>
            </div>

            {/* ——— RIGHT SECTION: CONTENIDO ORIGINAL ——— */}
            <div className="right-section" style={rightSectionStyle}>
              <div className="column" style={columnStyle}>
                <h2 style={titleStyle}>Lab-Demoss</h2>
                <p style={textStyle}>
                  <strong>{t('footer.dir')}: </strong>
                  {props.data ? props.data.address : "Cargando..."}
                </p>
                <p style={textStyle}>
                  <strong>Email:</strong>{" "}
                  {props.data ? props.data.email : "Cargando..."}
                </p>
              </div>
              <div className="column" style={columnStyle}>
                <h2 style={titleStyle}>Links</h2>
                <ul style={linkListStyle}>
                  <li style={linkItemStyle}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick();
                      }}
                      style={linkStyle}
                    >
                      Co'ox
                    </a>
                  </li>
                  <li style={linkItemStyle}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/encuesta");
                      }}
                      style={linkStyle}
                    >
                      {t('footer.enc')}
                    </a>
                  </li>
                  <li style={linkItemStyle}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowTyC(true);
                      }}
                      style={linkStyle}
                    >
                      {t('footer.tyc')}
                    </a>
                  </li>
                  <li style={linkItemStyle}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowAP(true);
                      }}
                      style={linkStyle}
                    >
                      {t('footer.pp')}
                    </a>
                  </li>
                  <li style={linkItemStyle}>
                    <a
                      href="https://maps.app.goo.gl/1T6t65m9yzo4ehMJ6"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={linkStyle}
                    >
                      {t('footer.vergoogle')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>

          {/* ——— FOOTER BOTTOM ——— */}
          <div className="footer-bottom" style={bottomStyle}>
            <p style={bottomTextStyle}>
              &copy; {new Date().getFullYear()} Lab-DEMOSS. {t('footer.tdr')}
            </p>
          </div>
        </div>
      </footer>

      {/* Modales */}
      <ModalTyC isOpen={showTyC} onClose={() => setShowTyC(false)} />
      <ModalAP isOpen={showAP} onClose={() => setShowAP(false)} />

      {/* Botón fijo “Volver arriba” */}
      <button
        onClick={scrollToTop}
        aria-label="Volver arriba"
        style={backToTopStyle}
      >
        ↑
      </button>
    </>
  );
};

// --- estilos existentes ---
const footerStyle = {
  backgroundColor: "#222",
  color: "#fff",
  padding: "40px 0",
};

const containerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "0 20px",
};

const footerContentStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "flex-start",
  marginBottom: "20px",
};

const leftSectionStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  marginRight: "40px",
};

const unamLogoStyle = {
  width: "130px",
  height: "auto",
};

const subLogosContainerStyle = {
  display: "flex",
  flexDirection: "column",
  marginLeft: "20px",
  gap: "8px",
};

// Ahora ambos sub-logos miden la mitad del ancho del logo UNAM (65px)
const subLogoStyle = {
  height: "auto",
  width: "65px",
};

const subLogoStyle2 = {
  height: "80px",
  width: "auto",
};

const rightSectionStyle = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  flex: "1",
};

const columnStyle = {
  flex: "1 1 45%",
  margin: "10px",
};

const titleStyle = {
  fontSize: "28px",
  marginBottom: "10px",
};

const textStyle = {
  fontSize: "16px",
  margin: "5px 0",
};

const linkListStyle = {
  listStyleType: "none",
  padding: 0,
};

const linkItemStyle = {
  margin: "5px 0",
};

const linkStyle = {
  color: "#fff",
  textDecoration: "none",
  fontSize: "16px",
};

const bottomStyle = {
  borderTop: "1px solid #444",
  paddingTop: "10px",
};

const bottomTextStyle = {
  fontSize: "14px",
  textAlign: "center",
};

const backToTopStyle = {
  position: "fixed",
  bottom: "20px",
  right: "20px",
  width: "40px",
  height: "40px",
  borderRadius: "20px",
  backgroundColor: "#222",
  color: "#fff",
  border: "none",
  cursor: "pointer",
  fontSize: "24px",
  lineHeight: "1",
  zIndex: 1002,
};
